<template>
  <div ref="blogSlider" class="swiper__carousel">
    <div class="swiper__row"> 
      <div v-for="(article,index) in data.articles" :key="index" class="swiper__col">
        <GridPrimary
          :article="article"
        />
      </div>
    </div>
    <div class="bs__nav bs__nav-prev">
      <svg class="bs__nav-prev-icon">
        <use xlink:href="#icon-prev"></use>
      </svg>
    </div>
    <div class="bs__nav bs__nav-next">
      <svg class="bs__nav-next-icon">
        <use xlink:href="#icon-next"></use>
      </svg>
    </div>
  </div>
</template>

<script setup>

  import { computed, toRefs, ref, onMounted } from 'vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';
  import GridPrimary from './components/grid-primary.vue'

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    data: {
      type: Array,
      required: true,
    }
  })

  var blogSlider = ref(null)

  onMounted(() =>{
    new Swiper(blogSlider.value, blogSwiper.value)
  })

  const blogSwiper = computed(() => {
    return {
      slidesPerView: 1.15,
      spaceBetween: 16,
      wrapperClass: 'swiper__row',
      slideClass: 'swiper__col', 
      navigation: {
        nextEl: '.bs__nav-next',
        prevEl: '.bs__nav-prev',
      },
      breakpoints: {
        768:{
          slidesPerView: 2.4,
          spaceBetween: 32,
        } 
      },
      a11y: true
    }
  });

</script>